module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pulldown', {
    ref: "reflash",
    attrs: {
      "top-method": _vm.topLoadMore
    }
  }, [_c('div', {
    staticClass: "mint-loadmore-top",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "slot": "top"
    },
    slot: "top"
  }, [_c('span', {
    attrs: {
      "v-show": _vm.topStatus == 'loading'
    }
  }, [_c('mt-spinner', {
    staticStyle: {},
    attrs: {
      "color": "#ff6634"
    }
  })], 1)]), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-aa00b92a"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/content/loadmore.vue
// module id = 214
// module chunks = 1